import React, { FunctionComponent } from "react";
import { Typography, Divider, Box } from "@material-ui/core";
import styled from "styled-components";
import { AppColor } from "../../styles/AppColor";

const StyledH1 = styled(Typography)`
  color: ${AppColor.h1Color};
`;

const ColoredDivider = styled(Divider)`
  background-color: ${props => props.theme.palette.secondary.main};
`;

type Property={
  title: string;
  my?: number;
}

export const HeadlineBlock: FunctionComponent<Property> = ({title, children, my=2}) =>(
  <Box my={my}>
    <StyledH1 variant="h1">
      {title}
    </StyledH1>
    {children}
    <ColoredDivider />
  </Box>
);